import getLang from 'I18n/utils/getLang';
import { View } from 'foundations-components/components/View';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { mapAppliedFiltersForRpc } from '../../search-results/utils/searchMappers';
import { useUmbrellaCollectionSections } from '../hooks/useUmbrellaCollectionSections';
import { BreezeAgentsCollectionSection } from './BreezeAgentsCollectionSection';
import { CollectionSection } from './CollectionSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UmbrellaCollectionSections({
  umbrellaCollection
}) {
  const {
    sections,
    loading,
    error
  } = useUmbrellaCollectionSections(umbrellaCollection);
  if (loading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      size: "medium",
      marginBlockStart: "1200"
    });
  }
  if (error) {
    return /*#__PURE__*/_jsx(ErrorMessage, {
      type: "badRequest"
    });
  }
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: "1200",
    children: [/*#__PURE__*/_jsx(BreezeAgentsCollectionSection, {
      sectionIndex: 0
    }), sections.map((section, index) => /*#__PURE__*/_jsx(CollectionSectionWithData, {
      section: section,
      sectionIndex: index + 1
    }, section.collectionId))]
  });
}
function CollectionSectionWithData({
  section,
  sectionIndex
}) {
  var _cardsQuery$data;
  // Load actual cards for this collection (following the same pattern as useCollectionApps)
  const cardsQuery = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      skip: !section.collectionId,
      variables: {
        queryType: 'ELASTIC_SEARCH',
        language: getLang(),
        collectionId: section.collectionId,
        offset: 0,
        length: 6,
        filter: mapAppliedFiltersForRpc([{
          field: 'PRODUCT_TYPE',
          dataType: 'STRING',
          values: ['APP']
        }])
      }
    }
  });
  const cards = ((_cardsQuery$data = cardsQuery.data) === null || _cardsQuery$data === void 0 ? void 0 : _cardsQuery$data.result.cards) || [];
  return /*#__PURE__*/_jsx(View, {
    marginBlockEnd: "1200",
    children: /*#__PURE__*/_jsx(CollectionSection, {
      cards: cards,
      collectionId: section.collectionId,
      collectionSlug: section.collectionSlug,
      description: section.description,
      sectionIndex: sectionIndex,
      title: section.title
    })
  });
}